import { ReactComponent as CourtIcon } from '@/assets/icons/ri-badminton-court.svg';
import { groupBookingHours } from '@/utils';

const dateFormat = (timestamp: string) => {
	const date = new Date(Number(timestamp));
	const day = date.toLocaleString('default', { day: '2-digit' });
	const month = date.toLocaleString('default', { month: 'long' });
	const year = date.toLocaleString('default', { year: 'numeric' });
	return `${day} ${month} ${year}`;
};

const courtData = (courts: { [key: string]: any }[]) => {
	const bookedCourts = {};
	courts.forEach((court) => {
		if (bookedCourts[court.venue_court_id]) {
			bookedCourts[court.venue_court_id].push(court);
		} else {
			bookedCourts[court.venue_court_id] = [{ ...court }];
		}
	});
	return bookedCourts;
};

const Schedule = ({ summary }): any => (
	<div className="flex flex-col p-0 gap-4">
		{Object.keys(summary).map((date) => {
			const courts = courtData(summary[date]);
			return (
				<div className="flex flex-col p-0 gap-4">
					<div className="flex flex-col py-2 gap-2 bg-grey-subtle">
						<div className="flex pl-2 gap-2">
							<p className="font-medium text-xs">{dateFormat(date)}</p>
						</div>
						<div className="flex border-b border-grey-line-subtle" />
					</div>
					{Object.keys(courts).map((courtId) => {
						const hours = groupBookingHours(
							courts[courtId].map((booking) => booking.start_time)
						);
						return (
							<div className="flex flex-col px-2 gap-2">
								<div className="flex items-center gap-4 p-0">
									<div className="flex flex-col justify-center items-center px-3 py-4 gap-2 bg-green-success rounded text-white">
										<CourtIcon />
									</div>
									<div className="flex flex-col">
										<p className="font-medium text-sm">
											{
												courts[courtId]?.find(
													(court) => court?.venue_court?.id === courtId
												)?.venue_court?.code
											}
										</p>
										{Object.values(hours).map((hour) => {
											const { start, end } = hour;
											return (
												<p className="text-xs text-grey-dark">
													{`${start}.00 - ${end}.00 WITA`}
												</p>
											);
										})}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			);
		})}
	</div>
);
export default Schedule;
